import styled from 'styled-components';

interface ITypography {
  theme: any;
  color?: string;
  whiteSpaceWrap?: boolean;
  ellipsis?: boolean;
}

export const H1 = styled.h1<ITypography>`
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ theme }) => theme.typography.h1};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
`;
export const H2 = styled.h2<ITypography>`
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ theme }) => theme.typography.h2};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ theme }) => theme.media.fold`
    ${theme.typography.h4}
  `}
`;
export const H3 = styled.h3<ITypography>`
  ${({ theme }) => theme.typography.h3};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
`;
export const H4 = styled.h4<ITypography>`
  ${({ theme }) => theme.typography.h4};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
`;
export const Title1 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.title1};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && `flex:1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;

export const Title4 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.title4};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && `flex:1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;

export const Subtitle1 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle1};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && `flex:1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle2 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle2};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle3 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle3};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle4 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle4};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle5 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle5};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle6 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle6};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap = false }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle7 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle7};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle8 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle8};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap = false }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;

export const Subtitle9 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle9};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
export const Subtitle10 = styled.div<ITypography>`
  ${({ theme }) => theme.typography.subtitle10};
  ${({ theme, color }) =>
    color &&
    `
    color: ${theme.color[color]};
  `};
  ${({ whiteSpaceWrap }) => whiteSpaceWrap && `white-space: initial`};
  ${({ ellipsis }) =>
    ellipsis && ` overflow: hidden; text-overflow: ellipsis; white-space: nowrap; `};
`;
